import { render, staticRenderFns } from "./CheT.vue?vue&type=template&id=34242b66"
import script from "./CheT.vue?vue&type=script&setup=true&lang=js"
export * from "./CheT.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports